import * as React from "react";
import styles from "./action-card.styles";

interface ActionCardProps {
  id?: string;
  className?: string;
}

const ActionCard: React.FC<ActionCardProps> = ({ id, className, children }) => {
  return (
    <div id={id} css={styles.card} className={className}>
      {children}
    </div>
  );
};

export default ActionCard;
